import FetchSettings from "../../../interfaces/FetchSettings";
import { UserJsonPage } from "../../../interfaces/JsonPage";
import {
  VanillaApiBadge,
  VanillaApiCurrentUser,
  VanillaApiRole,
  VanillaApiUser,
} from "../../../interfaces/VanillaApi";
import { getMode } from "../../../utilities";
import LocalProvider from "./LocalProvider";

export default class LocalUsersProvider extends LocalProvider {
  protected communityUrl = process.env.VANILLA_COMMUNITY_URL;

  public async getCurrentUser(): Promise<VanillaApiCurrentUser> {
    const apiUrl = new URL(this.baseUrl + "users/me");
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const data: VanillaApiCurrentUser = await this.request(
      url.toString(),
      settings
    );
    return data;
  }

  async getCurrentUserFromJsonPage(): Promise<UserJsonPage> {
    const currentUser = await this.getCurrentUser();
    const roles: Array<"Administrator" | "Moderator"> = [];
    const isAdmin = currentUser.permissions.some(
      (permission: string) => permission === "settings.view"
    );
    const isModerator = currentUser.permissions.some(
      (permission: string) => permission === "community.moderate"
    );
    isAdmin ? roles.push("Administrator") : "";
    isModerator ? roles.push("Moderator") : "";
    return {
      Profile: {
        UserID: currentUser.userID,
        Name: currentUser.name,
        Points: 120905,
        PhotoUrl: currentUser.photoUrl,
      },
      UserRoles: roles,
      Rank: {
        RankID: 15,
        Level: 14,
        Name: "Jadeite",
        Label: "Jadeite",
        CssClass: "rank-jadeite",
      },
    };
  }

  public async getUsersByName(keyword: string): Promise<Array<VanillaApiUser>> {
    console.log("  Getting users with name " + keyword);
    const settings: FetchSettings = {
      method: "GET",
    };
    const users: Array<VanillaApiUser> = await this.request(
      this.baseUrl +
        "users/by-names?access_token=Bearer " +
        process.env.VANILLA_API_TOKEN +
        "&name=" +
        keyword,
      settings
    );
    return users;
  }

  public async getUserById(id: number): Promise<VanillaApiUser> {
    const apiUrl = this.baseUrl + "users/" + id;
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const user: VanillaApiUser = await this.request(url.toString(), settings);
    return user;
  }

  public async getUserBadges(userId: number): Promise<Array<VanillaApiBadge>> {
    const apiUrl = this.baseUrl + "users/" + userId + "/badges";
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const badges: Array<VanillaApiBadge> = await this.request(
      url.toString(),
      settings
    );
    return badges;
  }

  public async getUserRoles(): Promise<Array<VanillaApiRole>> {
    const apiUrl = this.baseUrl + "roles";
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const roles: Array<VanillaApiRole> = await this.request(
      url.toString(),
      settings
    );
    return roles;
  }
}
